import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export const SIGNER_META = {
  founder: { label: "Founder", color: "#F5A524" },
  host: { label: "Host", color: "#FF3B30" },
  cohost: { label: "Co-Host", color: "#38BDF8" },
};
export const FIELD_LABEL = { signature: "Signature", initials: "Initials", date: "Date", name: "Printed Name", text: "Text", checkbox: "Checkbox" };
export const FIELD_SIZE = { signature: [160, 30], initials: [60, 30], date: [90, 15], name: [150, 15], text: [150, 15], checkbox: [12, 12] };
const STATUS = {
  draft: ["Draft", "text-[var(--ff-text-dim)] border-[var(--ff-border)]"],
  sent: ["Awaiting Signatures", "text-yellow-300 border-yellow-300/40"],
  completed: ["Completed", "text-emerald-400 border-emerald-400/40"],
  voided: ["Voided", "text-[var(--ff-red)] border-[var(--ff-red)]/40"],
};

export function StatusBadge({ status, testId }) {
  const [label, cls] = STATUS[status] || [status, ""];
  return <span className={`inline-block border px-2 py-0.5 font-mono-ui text-[0.6rem] uppercase tracking-[0.15em] ${cls}`} data-testid={testId}>{label}</span>;
}

export function useAuthBlob(path) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!path) return undefined;
    let alive = true;
    let made;
    api.get(path, { responseType: "blob" }).then((r) => {
      if (!alive) return;
      made = URL.createObjectURL(r.data);
      setUrl(made);
    }).catch(() => {});
    return () => { alive = false; if (made) URL.revokeObjectURL(made); };
  }, [path]);
  return url;
}

async function signedPdfUrl(id) {
  const r = await api.get(`/contracts/${id}/download`, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}

export async function downloadSigned(id, title) {
  const url = await signedPdfUrl(id);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${title} (signed).pdf`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export async function printSigned(id) {
  const url = await signedPdfUrl(id);
  const frame = document.createElement("iframe");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  frame.src = url;
  frame.onload = () => { try { frame.contentWindow.focus(); frame.contentWindow.print(); } catch { window.open(url, "_blank"); } };
  document.body.appendChild(frame);
  setTimeout(() => { frame.remove(); URL.revokeObjectURL(url); }, 120000);
}

export const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
